import { PreactView } from 'common/module/preact/view';
import { TooltipService } from 'common/service/tooltip/service';
import { PropertyCallTooltipTemplate } from 'desktop/module/property/call-tooltip/template';
import { PropertyCallTooltipView } from 'desktop/module/property/call-tooltip/view';
import { PropertyCallTooltipViewStoreFactory } from 'desktop/module/property/call-tooltip/view-store.factory';

const tooltip = new PropertyCallTooltipView(
  TooltipService(),
  new PreactView(PropertyCallTooltipTemplate, PropertyCallTooltipViewStoreFactory())
);

export function PropertyCallTooltipService(): PropertyCallTooltipView {
  return tooltip;
}
